import globalTypes from "reducers/types/global";

export const types = {
    CREATE_THIRDPAYMENT_REQUEST: "thirdPayment/CREATE_THIRDPAYMENT_REQUEST",
    CREATE_THIRDPAYMENT_SUCCESS: "thirdPayment/CREATE_THIRDPAYMENT_SUCCESS",
    CREATE_THIRDPAYMENT_FAILURE: "thirdPayment/CREATE_THIRDPAYMENT_FAILURE",
    SET_SUMMARY_THIRDPAYMENT: "thirdPayment/SET_SUMMARY_THIRDPAYMENT",
    LOAD_LIST_REQUEST: "thirdPayment/LOAD_LIST_REQUEST",
    LOAD_LIST_FAILURE: "thirdPayment/LOAD_LIST_FAILURE",
    LOAD_LIST_SUCCESS: "thirdPayment/LOAD_LIST_SUCCESS",
    LOAD_MORE_LIST_REQUEST: "thirdPayment/LOAD_MORE_LIST_REQUEST",
    LOAD_MORE_LIST_FAILURE: "thirdPayment/LOAD_MORE_LIST_FAILURE",
    LOAD_MORE_LIST_SUCCESS: "thirdPayment/LOAD_MORE_LIST_SUCCESS",
    LOAD_THIRDPAYMENT: "thirdPayment/LOAD_THIRDPAYMENT",
    LOAD_TRANSACTION_REQUEST: "thirdPayment/LOAD_TRANSACTION_REQUEST",
    LOAD_TRANSACTION_SUCCESS: "thirdPayment/LOAD_TRANSACTION_SUCCESS",
    LOAD_TRANSACTION_FAILURE: "thirdPayment/LOAD_TRANSACTION_FAILURE",
    CLEAR_DATA: "thirdPayment/CLEAR_DATA",
    SET_TYPEH: "thirdPayment/SET_TYPEH",
    SET_TYPESU: "thirdPayment/SET_TYPESU",
    DOWNLOAD_TRANSACTION_LINE_REQUEST: "thirdPayment/DOWNLOAD_TRANSACTION_LINE_REQUEST",
    DOWNLOAD_TRANSACTION_LINE_FAILURE: "thirdPayment/DOWNLOAD_TRANSACTION_LINE_FAILURE",
    DOWNLOAD_TRANSACTION_LINE_SUCCESS: "thirdPayment/DOWNLOAD_TRANSACTION_LINE_SUCCESS",
    DOWNLOAD_LIST_REQUEST: "thirdPayment/DOWNLOAD_LIST_REQUEST",
    DOWNLOAD_LIST_FAILURE: "thirdPayment/DOWNLOAD_LIST_FAILURE",
    DOWNLOAD_LIST_SUCCESS: "thirdPayment/DOWNLOAD_LIST_SUCCESS",

    DOWNLOAD_TRANSACTION_FILE_REQUEST: "thirdPayment/DOWNLOAD_TRANSACTION_FILE_REQUEST",
    DOWNLOAD_TRANSACTION_FILE_FAILURE: "thirdPayment/DOWNLOAD_TRANSACTION_FILE_FAILURE",
    DOWNLOAD_TRANSACTION_FILE_SUCCESS: "thirdPayment/DOWNLOAD_TRANSACTION_FILE_SUCCESS",
    DOWNLOAD_CONFIRMATION_REQUEST: "thirdPayment/DOWNLOAD_CONFIRMATION_REQUEST",
    DOWNLOAD_CONFIRMATION_FAILURE: "thirdPayment/DOWNLOAD_CONFIRMATION_FAILURE",
    DOWNLOAD_CONFIRMATION_SUCCESS: "thirdPayment/DOWNLOAD_CONFIRMATION_SUCCESS",
    SET_PAGE_TO_GO_BACK: "thirdPayment/SET_PAGE_TO_GO_BACK",
    THIRDPAYMENT_TICKET_SUCCESS: "thirdPayment/THIRDPAYMENT_TICKET_SUCCESS",
    CLEAN_THIRDPAYMENT_TICKET: "thirdPayment/CLEAN_THIRDPAYMENT_TICKET",

    SET_THIRD_PARTIE_FILTERS: "thirdPayment/SET_THIRD_PARTIE_FILTERS",

    DOWNLOAD_DOCUMENT_REQUEST: "thirdPayment/DOWNLOAD_DOCUMENT_REQUEST",
    DOWNLOAD_DOCUMENT_FAILURE: "thirdPayment/DOWNLOAD_DOCUMENT_FAILURE",
    DOWNLOAD_DOCUMENT_SUCCESS: "thirdPayment/DOWNLOAD_DOCUMENT_SUCCESS",
    CANCEL_THIRDPAYMENT_REQUEST: "thirdPayment/CANCEL_THIRDPAYMENT_REQUEST",
    SET_LOADING: "thirdPayment/SET_LOADING",

    VALIDATE_DATE_REQUEST: "thirdPayment/VALIDATE_DATE_REQUEST",
    VALIDATE_DATE_FAILURE: "thirdPayment/VALIDATE_DATE_FAILURE",
    VALIDATE_DATE_SUCCESS: "thirdPayment/VALIDATE_DATE_SUCCESS",

    RESET_SELECTED_ELEMENTS: "thirdPayment/RESET_SELECTED_ELEMENTS",

    PAYMENT_RECOLLECTION_REQUEST: "thirdPayment/PAYMENT_RECOLLECTION_REQUEST",
    PAYMENT_RECOLLECTION_SUCCESS: "thirdPayment/PAYMENT_RECOLLECTION_SUCCESS",
    PAYMENT_RECOLLECTION_FAILURE: "thirdPayment/PAYMENT_RECOLLECTION_FAILURE",
    PAYMENT_RECOLLECTION_RESET: "thirdPayment/PAYMENT_RECOLLECTION_RESET",

    PAYROLL_UPLOAD_DOCUMENT_REQUEST: "thirdPayment/PAYROLL_UPLOAD_DOCUMENT_REQUEST",
    PAYROLL_UPLOAD_DOCUMENT_FAILURE: "thirdPayment/PAYROLL_UPLOAD_DOCUMENT_FAILURE",
    PAYROLL_UPLOAD_DOCUMENT_SUCCESS: "thirdPayment/PAYROLL_UPLOAD_DOCUMENT_SUCCESS",

    PAYROLL_DELETE_DOC_REQUEST: "thirdPayment/PAYROLL_DELETE_DOC_REQUEST",
    PAYROLL_DELETE_DOC_SUCCESS: "thirdPayment/PAYROLL_DELETE_DOC_SUCCESS",
    PAYROLL_DELETE_DOC_FAILURE: "thirdPayment/PAYROLL_DELETE_DOC_FAILURE",

    PAYROLL_CLEAN_REQUEST: "thirdPayment/PAYROLL_CLEAN_REQUEST",
    PAYROLL_SET_UPLOAD_ERROR_REQUEST: "thirdPayment/PAYROLL_SET_UPLOAD_ERROR_REQUEST",
    PAYROLL_SET_DOCCONFIRM_REQUEST: "thirdPayment/PAYROLL_SET_DOCCONFIRM_REQUEST",

    PAYROLL_SEND_REQUEST: "thirdPayment/PAYROLL_SEND_REQUEST",
    PAYROLL_SEND_SUCCESS: "thirdPayment/PAYROLL_SEND_SUCCESS",
    PAYROLL_SEND_FAILURE: "thirdPayment/PAYROLL_SEND_FAILURE",

    PAYROLL_DOWNLOAD_TEMPLATE_REQUEST: "thirdPayment/PAYROLL_DOWNLOAD_TEMPLATE_REQUEST",

    PAYROLL_LIST_DOWNLOADS_REQUEST: "thirdPayment/PAYROLL_LIST_DOWNLOADS_REQUEST",
    PAYROLL_LIST_DOWNLOADS_SUCCESS: "thirdPayment/PAYROLL_LIST_DOWNLOADS_SUCCESS",
    PAYROLL_LIST_DOWNLOADS_FAILURE: "thirdPayment/PAYROLL_LIST_DOWNLOADS_FAILURE",

    PAYROLL_GET_DOWNLOAD_REQUEST: "thirdPayment/PAYROLL_GET_DOWNLOAD_REQUEST",
    PAYROLL_GET_DOWNLOAD_SUCCESS: "thirdPayment/PAYROLL_GET_DOWNLOAD_SUCCESS",
    PAYROLL_GET_DOWNLOAD_FAILURE: "thirdPayment/PAYROLL_GET_DOWNLOAD_FAILURE",

};

export const INITIAL_STATE = {
    fetching: false,
    transactionLinesStatus: [],
    dateFrom: null,
    dateTo: null,
    amountFrom: null,
    typeSelect: true,
    amountTo: null,
    status: "",
    idTransaction: "",
    fetchingDownload: false,
    thirdPaymentData: {},
    isFirstFetching: true,
    pageToGoBack: null,
    filterThirdParties: {},
    thirdPartiesTicket: { status: "", idTransaction: "" },
    isValidDate: null,
    recolection: {},
    recolectionsLoading: false,
    externalUploadError: null,
    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null, fileId: 0 },
    documentToConfirm: null,
    payrollFetching: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        filters = {},
        thirdPaymentData,
        summary,
        signatures,
        pendingDispatch,
        idTransactionStatus,
        modificationDateTime,
        userEditorFullName,
        creatorFullName,
        creationDate,
        transactionLinesStatus,
        idTransaction,
        transaction,
        latestTotalPages,
        latestPageNumber,
        pageToGoBack,
        thirdPartiesTicket,
        fetching,
        data,
        isValidDate,
        recolection,
        externalUploadError,
        documentToUploadRequest,
        documentCode,
        documentToConfirm,
        payrollFetching,
        payrollDownloadsList,
        fileId,
    } = action;
    switch (action.type) {
        case types.CREATE_THIRDPAYMENT_REQUEST:
            return {
                ...state,
                fetching: true,
                summary,
            };
        case types.CLEAR_DATA:
            return {
                ...state,
                ...INITIAL_STATE,
                summary: {},
            };
        case types.SET_TYPEH:
            return {
                ...state,
                typeSelect: false,
                transactionLinesStatus: [],
            };
        case types.SET_TYPESU:
            return {
                ...state,
                typeSelect: true,
                transactionLinesStatus: [],
            };
        case types.CREATE_THIRDPAYMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                summary: {
                    ...state.summary,
                    signatures,
                    pendingDispatch,
                    idTransactionStatus,
                    modificationDateTime,
                    userEditorFullName,
                    creatorFullName,
                    creationDate,
                },
            };

        case types.CREATE_THIRDPAYMENT_FAILURE:
            return {
                ...state,
                fetching: false,
                summary,
            };
        case types.SET_SUMMARY_THIRDPAYMENT:
            return {
                ...state,
                thirdPaymentData,
            };

        case types.LOAD_LIST_REQUEST:
            return {
                ...state,
                ...filters,
                fetching: true,
                isFirstFetching: filters.isFirstFetching,
            };
        case types.LOAD_LIST_FAILURE:
            return {
                fetching: false,
                isFirstFetching: false,
            };
        case types.LOAD_LIST_SUCCESS:
            return {
                ...state,
                transactionLinesStatus,
                latestTotalPages,
                latestPageNumber,
                fetching: false,
                isFirstFetching: false,
            };

        case types.LOAD_MORE_LIST_REQUEST:
            return {
                ...state,
                ...filters,
                fetching: true,
            };
        case types.LOAD_MORE_LIST_FAILURE:
            return {
                fetching: false,
            };
        case types.LOAD_MORE_LIST_SUCCESS:
            return {
                ...state,
                transactionLinesStatus: state.transactionLinesStatus.concat(transactionLinesStatus),
                latestTotalPages,
                latestPageNumber,
                fetching: false,
            };

        case types.LOAD_THIRDPAYMENT:
            return {
                ...state,
                summary,
            };
        case types.LOAD_THIRDPAYMENT_REQUEST:
            return {
                ...state,
                fetching: true,
                transaction,
            };
        case types.LOAD_THIRDPAYMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                summary: { ...state.summary },
            };
        case types.LOAD_TRANSACTION_REQUEST:
            return {
                ...state,
                idTransaction,
                fetching: true,
            };
        case types.LOAD_TRANSACTION_SUCCESS:
            return {
                ...state,
                fetching: false,
                transaction: {
                    ...data,
                },
            };
        case types.LOAD_TRANSACTION_FAILURE:
            return {
                ...state,
                fetching: true,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_REQUEST:
            return {
                ...state,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_LIST_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_LIST_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_LIST_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_CONFIRMATION_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_CONFIRMATION_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_CONFIRMATION_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.SET_PAGE_TO_GO_BACK:
            return {
                ...state,
                pageToGoBack,
            };
        case types.SET_THIRD_PARTIE_FILTERS:
            return {
                ...state,
                filterThirdParties: { ...state.filterThirdParties, ...action.filters },
            };
        case types.THIRDPAYMENT_TICKET_SUCCESS:
            return {
                ...state,
                thirdPartiesTicket,
            };
        case types.DOWNLOAD_DOCUMENT_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case globalTypes.RESET_SELECTED_ELEMENTS:
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        case types.CLEAN_THIRDPAYMENT_TICKET:
            return {
                ...state,
                thirdPartiesTicket: { status: "", idTransaction: "" },
            };
        case types.SET_LOADING:
            return {
                ...state,
                fetching,
            };
        case types.VALIDATE_DATE_REQUEST:
            return {
                ...state,
                isValidDate: null,
            };
        case types.VALIDATE_DATE_FAILURE:
            return {
                ...state,
                isValidDate: false,
            };
        case types.VALIDATE_DATE_SUCCESS:
            return {
                ...state,
                isValidDate,
            };
        case types.RESET_SELECTED_ELEMENTS:
            return {
                ...INITIAL_STATE,
            };
        case types.PAYMENT_RECOLLECTION_REQUEST:
            return {
                ...state,
                recolectionsLoading: true,
            };
        case types.PAYMENT_RECOLLECTION_SUCCESS:
            return {
                ...state,
                recolection,
                recolectionsLoading: false,
            };
        case types.PAYMENT_RECOLLECTION_FAILURE:
            return {
                ...state,
                recolection,
                recolectionsLoading: false,
            };
        case types.PAYMENT_RECOLLECTION_RESET:
            return {
                ...state,
                recolection: {},
                recolectionsLoading: false,
            };
        case types.PAYROLL_CLEAN_REQUEST:
                return {
                    ...state,
                    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null , fileId: 0 },
                    externalUploadError: null,
                };       
        case types.PAYROLL_SET_UPLOAD_ERROR_REQUEST:
            return {
                ...state,
                externalUploadError,
            };
        case types.PAYROLL_UPLOAD_DOCUMENT_REQUEST:
                return {
                    ...state,
                    documentToUploadRequest: { status: "FETCHING", value: "", error: null, id: documentCode, fileId: 0},
                };
        case types.PAYROLL_UPLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "SUCCESS",
                    value: documentToUploadRequest,
                    error: null,
                    id: documentCode,
                    fileId: fileId,
                },
            };
        case types.PAYROLL_UPLOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "FAILURE",
                    value: "",
                    error: null,
                    id: null,
                    fileId: 0
                },
            };
        case types.PAYROLL_SET_DOCCONFIRM_REQUEST:
                return {
                    ...state,
                    documentToConfirm,
                };
        case types.PAYROLL_DELETE_DOC_REQUEST:
             return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null, fileId: 0 },
            };
        case types.PAYROLL_SEND_REQUEST:
                return {
                    ...state,
                    payrollFetching: true,
                };
        case types.PAYROLL_SEND_FAILURE:
        case types.PAYROLL_SEND_SUCCESS:
            return {
                ...state,
                payrollFetching: false,
            };
        case types.PAYROLL_LIST_DOWNLOADS_REQUEST:
                return {
                    ...state,
                    fetching: true,
                };
        case types.PAYROLL_LIST_DOWNLOADS_SUCCESS:
            return {
                ...state,
                payrollDownloadsList,
                fetching: false,
            };
        case types.PAYROLL_LIST_DOWNLOADS_FAILURE:
            return {
                ...state,
                fetching: false,
                payrollDownloadsList: null,
            };
        case types.PAYROLL_GET_DOWNLOAD_REQUEST:
                return {
                    ...state,
                    fetching: true,
                };
        case types.PAYROLL_GET_DOWNLOAD_SUCCESS:
        case types.PAYROLL_GET_DOWNLOAD_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        default:
            return state;
    }
};
export const actions = {
    validateThirdPay: (summary, formikBag, credentialType) => ({
        type: types.CREATE_THIRDPAYMENT_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),
    clearData: () => ({
        type: types.CLEAR_DATA,
    }),
    setTypeH: () => ({
        type: types.SET_TYPEH,
    }),
    setTypeSU: () => ({
        type: types.SET_TYPESU,
    }),
    summaryThirdPay: (thirdPaymentData) => ({
        type: types.SET_SUMMARY_THIRDPAYMENT,
        thirdPaymentData,
    }),
    loadListThirdRequest: (filters) => ({
        type: types.LOAD_LIST_REQUEST,
        filters,
    }),
    loadMoreListThirdRequest: (filters) => ({
        type: types.LOAD_MORE_LIST_REQUEST,
        filters,
    }),
    loadConfirmThirdPayment: (summary) => ({
        type: types.LOAD_THIRDPAYMENT,
        summary,
    }),
    getTransaction: (idTransaction, getFileContest) => ({
        type: types.LOAD_TRANSACTION_REQUEST,
        idTransaction,
        getFileContest,
    }),
    downloadTransactionLines: (format, transactionLines) => ({
        type: types.DOWNLOAD_TRANSACTION_LINE_REQUEST,
        format,
        transactionLines,
    }),
    downloadListThirdPayment: (format, filterThirdParties) => ({
        type: types.DOWNLOAD_LIST_REQUEST,
        format,
        filterThirdParties,
    }),
    downloadFileTransaction: (
        format,
        transactionLines,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
    ) => ({
        type: types.DOWNLOAD_TRANSACTION_FILE_REQUEST,
        format,
        transactionLines,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
        isDetailDownload: true,
    }),
    downloadFileTransactionItem: (
        format,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
    ) => ({
        type: types.DOWNLOAD_TRANSACTION_FILE_REQUEST,
        format,
        transactionLines: null,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
        isDetailDownload: false,
    }),
    downloadConfirmation: (summary) => ({
        type: types.DOWNLOAD_CONFIRMATION_REQUEST,
        summary,
    }),
    setPageToGoBack: (pageToGoBack) => ({
        type: types.SET_PAGE_TO_GO_BACK,
        pageToGoBack,
    }),
    setThirdPartiesFilters: (filters) => ({
        type: types.SET_THIRD_PARTIE_FILTERS,
        filters,
    }),
    cleanThirdPartiesTicket: () => ({
        type: types.CLEAN_THIRDPAYMENT_TICKET,
    }),
    downloadDocument: (fileId) => ({
        type: types.DOWNLOAD_DOCUMENT_REQUEST,
        fileId,
    }),
    cancelTransaction: (summary, formikBag, credentialType) => ({
        type: types.CANCEL_THIRDPAYMENT_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),
    setLoading: (fetching) => ({
        type: types.SET_LOADING,
        fetching,
    }),
    validateDate: (dateProcess) => ({
        type: types.VALIDATE_DATE_REQUEST,
        dateProcess,
    }),
    resetThirdPayment: () => ({
        type: types.RESET_SELECTED_ELEMENTS,
    }),
    getRecollectionJWT: () => ({
        type: types.PAYMENT_RECOLLECTION_REQUEST,
    }),
    clearRecollectionJWT: () => ({
        type: types.PAYMENT_RECOLLECTION_RESET,
    }),
    setPayrollUploadError: (externalUploadError) => ({
        type: types.PAYROLL_SET_UPLOAD_ERROR_REQUEST,
        externalUploadError,
    }),
    payrollDocumentDelete: (fileId) => ({
        type: types.PAYROLL_DELETE_DOC_REQUEST,
        fileId,
    }),
    payrollUploadDocument: (documentToUpload) => ({
        type: types.PAYROLL_UPLOAD_DOCUMENT_REQUEST,
        documentToUpload,
        documentCode: documentToUpload.uploaderRequestId,
    }),
    setDocumentToConfirm: (documentToConfirm) => ({
        type: types.PAYROLL_SET_DOCCONFIRM_REQUEST,
        documentToConfirm,
    }),
    payrollClean: () => ({
        type: types.PAYROLL_CLEAN_REQUEST,
    }),
    payrollSend: (params, formikBag) => ({
        type: types.PAYROLL_SEND_REQUEST,
        params,
        formikBag,
    }),
    downloadPayrollTemplate: () => ({
        type: types.PAYROLL_DOWNLOAD_TEMPLATE_REQUEST,
    }),
    listPayrollDownloads: (params) => ({
        type: types.PAYROLL_LIST_DOWNLOADS_REQUEST,
        params,
    }),
    getPayrollDownload: (params) => ({
        type: types.PAYROLL_GET_DOWNLOAD_REQUEST,
        params,
    }),
};

export const selectors = {
    getFetching: ({ thirdPayment }) => thirdPayment.fetching,
    getTypePayment: ({ thirdPayment }) => thirdPayment.summary.typePayment,
    getCurrency: ({ thirdPayment }) => thirdPayment.summary.currency,
    getAmount: ({ thirdPayment }) => thirdPayment.summary.amount,
    getAccount: ({ thirdPayment }) => thirdPayment.summary.account,
    getDateProcess: ({ thirdPayment }) => thirdPayment.summary.dateProcess,
    getReferente: ({ thirdPayment }) => thirdPayment.summary.description,
    getTransaction: ({ thirdPayment }) => thirdPayment.transaction,
    getTransactionLinesStatus: ({ thirdPayment }) => thirdPayment.transactionLinesStatus,
    getFile: ({ thirdPayment }) => thirdPayment.summary.file,
    getSummary: ({ thirdPayment }) => thirdPayment.summary,
    getTypeSelect: ({ thirdPayment }) => thirdPayment.typeSelect,
    getFetchingDownload: ({ thirdPayment }) => thirdPayment.fetchingDownload,
    getLatestPageNumber: ({ thirdPayment }) => thirdPayment.latestPageNumber,
    getLatestTotalPages: ({ thirdPayment }) => thirdPayment.latestTotalPages,
    isFirstFetching: ({ thirdPayment }) => thirdPayment.isFirstFetching,
    getPageToGoBack: ({ thirdPayment }) => thirdPayment.pageToGoBack,
    getDocumentToConfirm: ({ thirdPayment }) => thirdPayment.documentToConfirm,
    isPayrollFetching: ({ thirdPayment }) => thirdPayment.payrollFetching,
    getPayrollDownloadsList: ({ thirdPayment }) => thirdPayment.payrollDownloadsList,
    getPayrollFileId: ({ thirdPayment }) => thirdPayment.documentToUploadRequest.fileId,
};
